import { render, staticRenderFns } from "./TabTable.vue?vue&type=template&id=77ef0a5a&scoped=true&"
import script from "./TabTable.vue?vue&type=script&lang=ts&"
export * from "./TabTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef0a5a",
  null
  
)

export default component.exports